import { useEffect, useState } from "react";
import { AppBar, Toolbar, Typography, Box, IconButton } from "@mui/material";
import UserMenu from "../components/Navbar/UserMenu";
import { useSnackbar } from "../components/SnackBar/SnackbarContext";
import { GetAllSchoolLeadNotificationList } from "../api/auth/authService";

import NotificationPopover from "./NotificationPopover";
import LeadStatusModal from "./LeadStatusModal";

export default function Navbar({ toggleSidebar }) {
  const { showSnackbar } = useSnackbar();
  const [rotated, setRotated] = useState(false);

  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const [loadingSchoolLeadNotificationList, setLoadingSchoolLeadNotificationList] = useState(true);
  const [schoolLeadNotificationList, setSchoolLeadNotificationList] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState(null);

  const handleClick = () => {
    setRotated((prev) => !prev);
    toggleSidebar();
  };

  const handleNotificationClick = (event) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
  };

  const openNotifications = Boolean(notificationAnchorEl);
  const notificationId = openNotifications ? 'notification-popover' : undefined;

  const handleNotificationItemClick = (school) => {
    handleNotificationClose();
    setSelectedSchool(school);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedSchool(null);
  };

  const fetchSchoolLeadNotificationList = async () => {
    setLoadingSchoolLeadNotificationList(true);
    try {
      const response = await GetAllSchoolLeadNotificationList();

      if (response.success && response.data) {
        const schoolOptions = response.data.map(school => ({
          id: school.schoolID,
          label: school.schoolName,
          date: school.followupDate
        }));
        setSchoolLeadNotificationList(schoolOptions);
      } else {
        setSchoolLeadNotificationList([]);
      }
    } catch (err) {
      setSchoolLeadNotificationList([]);
      showSnackbar("Failed to load school notifications", "error");
    } finally {
      setLoadingSchoolLeadNotificationList(false);
    }
  };

  useEffect(() => {
    fetchSchoolLeadNotificationList();
  }, []);

  return (
    <>
      <AppBar position="fixed" className="custom-navbar shadow-none" sx={{ bgcolor: "white", color: "black", boxShadow: 'none', borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
        <Toolbar>
          <Box className="sidebar-header" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <img src="http://www.logoai.com/oss/icons/2021/12/02/EoLJeYhT6YPfd26.png" alt="logo" width={30} />
            <Typography sx={{ color: '#525b75cc', fontSize: 20, fontWeight: 600, letterSpacing: '-0.04em' }}>Controlpanel</Typography>
          </Box>

          <Box sx={{ flexGrow: 1, ml: 3 }}>
            <i className="fa-sharp fa-regular fa-arrow-left-long-to-line" onClick={handleClick} style={{ color: '#525b75cc', cursor: 'pointer' }}></i>
          </Box>
          <Box display='flex' alignItems='center' gap={1}>
            <IconButton onClick={handleNotificationClick} sx={{ borderRadius: '5px' }} aria-describedby={notificationId}>
              <i className="fa-sharp fa-regular fa-bell" style={{ color: '#525b75cc', fontSize: '16px' }}></i>
            </IconButton>

            <UserMenu />
          </Box>
        </Toolbar>

        {/* Notification Popover */}
        <NotificationPopover
          id={notificationId}
          open={openNotifications}
          anchorEl={notificationAnchorEl}
          onClose={handleNotificationClose}
          loading={loadingSchoolLeadNotificationList}
          notifications={schoolLeadNotificationList}
          onItemClick={handleNotificationItemClick}
        />
      </AppBar>

      {/* Lead Status Modal */}
      <LeadStatusModal
        open={openModal}
        onClose={handleCloseModal}
        isEditMode={!!selectedSchool}
        schoolOptions={schoolLeadNotificationList}
        selectedSchool={selectedSchool}
      />
    </>
  );
}